import { Component, Input } from '@angular/core';
import { PayeeOverride } from '@core/typings/payment.typing';

@Component({
  selector: 'gc-special-handling-display-line',
  templateUrl: './special-handling-display-line.component.html',
  styleUrls: ['./special-handling-display-line.component.scss']
})
export class SpecialHandlingDisplayLineComponent {
  @Input() payeeOverride: PayeeOverride;
  @Input() isInternational: boolean;
  @Input() isClientProcessing = false;
  @Input() showName = false;
}
